import { useEffect } from 'react';

/**
 * "Add to Home screen" installs the team app: full screen, its own icon, no
 * browser bar. The manifest is attached from the SIGNED-IN screens that call
 * this hook, not from index.html: the same index.html serves the public
 * customer /order page, which must never offer customers "Install Team Daksha".
 */
export default function useTeamAppManifest() {
    useEffect(() => {
        if (document.querySelector('link[rel="manifest"]')) return;
        const link = document.createElement('link');
        link.rel = 'manifest';
        link.href = '/team-manifest.webmanifest';
        document.head.appendChild(link);
        const theme = document.querySelector('meta[name="theme-color"]');
        if (theme) theme.setAttribute('content', '#ffffff');
    }, []);
}
